import { paymentConfigProps } from '../types';

const initialPaymentConfigData: paymentConfigProps = {
  razorpay: {
    apiUsername: '',
    apiPassword: ''
  },
  logoUrl: '',
  receiptTemplateId: '',
  gradeWiseConfig: [],
  featureConfigs: {
    enachPayment: {
      enabled: false
    },
    installmentPaymentLink: {
      enabled: false,
      offsetDays: []
    }
    
  }
};

export { initialPaymentConfigData };
